import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { key, hash } = useLocation(); // 'key' changes on every click/navigation

    useEffect(() => {
        if (hash) {
            const targetId = hash.replace('#', '');
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            }
        }

        window.scrollTo(0, 0);
    }, [key, hash]);

    return null;
};

export default ScrollToTop;